<template>
    <div
        class="flex flex-col items-center justify-center flex-grow w-full mx-10"
    >
        <component
            ref="tools"
            v-for="(tools, index) in toolsCard"
            :key="tools.key"
            :is="tools.model"
            :data="tools.object"
            v-on:remove="removeTool($event, index)"
        />
        <base-add-button
            title="Ajouter Matériels et outillage"
            @click="pushArray"
        />
        <div class="grid items-center justify-center w-full grid-cols-10 ">
            <base-primary-button
                title="Suivant"
                @click="nextStep"
                class="w-full col-span-6 col-start-3"
            />
            <div
                @click="skipStep"
                class="flex items-center justify-center col-span-2 col-start-9 p-3 mb-6 space-x-2 text-gray-500 cursor-pointer hover:underline hover:text-gray-800 "
            >
                <span>Ignorer cette étape</span>
                <svg
                    class="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 5l7 7-7 7M5 5l7 7-7 7"
                    ></path>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import ToolsCard from "./components/ToolsCard";
import { mapState } from "vuex";
import { scrollToError } from "@/mixins/scrollToMixin.js";

export default {
    components: {
        ToolsCard
    },
    data() {
        return {
            toolsCard: []
        };
    },
    mixins: [scrollToError],
    mounted() {
        this.toolsCard = this.$store.getters["EtudeTechnique/getTools"];
        this.$store.dispatch("forms/currentStep", "Matériels et outillage");
    },

    methods: {
        removeTool(payload, index) {
            this.$store.dispatch("EtudeTechnique/removeTool", payload);
            this.toolsCard.splice(index, 1);
        },
        nextStep() {
            if (!this.checkForms() && this.toolsLength >= 1) {
                this.$store.dispatch("EtudeTechnique/SaveTools");
                this.$router.push({
                    name: "moyens_de_transports_et_manutentions",
                    params: { uid: `${this.$store.state.user.bpiId}` }
                });
            } else {
                this.scrollToError();

                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        },
        pushArray() {
            if (!this.checkForms()) {
                this.toolsCard.push({
                    model: "tools-card",
                    key: new Date().getTime(),
                    object: {
                        id: new Date().getTime(),
                        isBuying: true,
                        designation: "",
                        number: 1,
                        characteristics: "",
                        state: "",
                        price: null,
                        providerName: "",
                        origin: "",
                        payedInAdvance: null,
                        rentPrice: null,
                        rentDuration: null
                    }
                });

                this.$refs.tools[this.$refs.tools.length - 1].scrollToRef();
            } else {
                this.scrollToError();

                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        },
        skipStep() {
            this.$router.push({
                name: "moyens_de_transports_et_manutentions",
                params: { uid: `${this.$store.state.user.bpiId}` }
            });
        },
        checkForms() {
            let formsHasError = false;
            this.$refs.tools.forEach(item => {
                if (!item.createTools()) {
                    formsHasError = true;
                }
            });
            return formsHasError;
        }
    },
    computed: {
        ...mapState("EtudeTechnique", {
            toolsLength: state => state.tools.length
        })
    }
};
</script>

<style></style>
